import { IIndicator, IInsight, IInsightDialog } from '@jumpstart/core';
import { User } from 'firebase/auth';
import { SlackService } from '../../services/slack-service';
import { validateDialogNode, validateIndicator, validateInsight } from './widgets/utils';

export default class InsightNotificationsService {

  public static async insight(event: IInsight, author: User, action: string): Promise<void> {
    const { warnings, errors } = validateInsight(event);
    await SlackService.notify({
      'blocks': [
        {
          'type': 'section',
          'text': {
            'type': 'mrkdwn',
            'text': `*${author.displayName} (${author.phoneNumber})* has ${action} *insight* "${event.name}"`
          }
        },
        {
          'type': 'divider'
        },
        {
          'type': 'context',
          'elements': [
            {
              'type': 'mrkdwn',
              'text': `*Description*: ${event.description}`
            },
            {
              'type': 'mrkdwn',
              'text': `*Type*: ${event.type}`
            },
            {
              'type': 'mrkdwn',
              'text': `(suggested) *Timeline*: ${this.timeline(event)}`
            },
            {
              'type': 'mrkdwn',
              'text': `*Indicators*: ${event.content.indicators.length}`
            },
            {
              'type': 'mrkdwn',
              'text': `*Severity*: ${event.severity}`
            },
            {
              'type': 'mrkdwn',
              'text': `${Object.keys(errors).length}❗ ${Object.keys(warnings).length}⚠️`
            }
          ]
        }
      ]
    })
      .catch((err: Error) => {
        console.error('Failed to notify', err);
      });
  }

  public static async indicator(
    insight: IInsight,
    indicator: IIndicator,
    author: User,
    action: string
  ): Promise<void> {
    const { warnings, errors } = validateIndicator(indicator);
    await SlackService.notify({
      'blocks': [
        {
          'type': 'section',
          'text': {
            'type': 'mrkdwn',
            'text': `*${author.displayName} (${author.phoneNumber})* has ${action} *indicator* within "${insight.name}" (insight) -> "${indicator.name}" (indicator)`
          }
        },
        {
          'type': 'divider'
        },
        {
          'type': 'context',
          'elements': [
            {
              'type': 'mrkdwn',
              'text': `*Description*: ${indicator.description}`
            },
            {
              'type': 'mrkdwn',
              'text': `${Object.keys(errors).length}❗ ${Object.keys(warnings).length}⚠️`
            }
          ]
        }
      ]
    })
      .catch((err: Error) => {
        console.error('Failed to notify', err);
      });
  }

  public static async dialog(
    insight: IInsight,
    indicator: IIndicator,
    dialog: IInsightDialog,
    author: User,
    action: string
  ): Promise<void> {
    const { warnings, errors } = validateDialogNode(dialog);
    await SlackService.notify({
      'blocks': [
        {
          'type': 'section',
          'text': {
            'type': 'mrkdwn',
            'text': `*${author.displayName} (${author.phoneNumber})* has ${action} *dialog* within "${insight.name}" (insight) -> "${indicator.name}" (indicator)`
          }
        },
        {
          'type': 'divider'
        },
        {
          'type': 'context',
          'elements': [
            {
              'type': 'mrkdwn',
              'text': `*Completion Event*: ${!!dialog.completionCriteria ? 'Yes' : 'No'}`
            },
            {
              'type': 'mrkdwn',
              'text': `*Response*: ${dialog.response}`
            },
            {
              'type': 'mrkdwn',
              'text': `*Action*: ${dialog.body}`
            },
            {
              'type': 'mrkdwn',
              'text': `*Question*: ${dialog.question}`
            },
            // ...(Object.keys(dialog.responses ? dialog.responses : {}).reduce((accumulator: any, key: string) => {
            //   accumulator.push({
            //         'type': 'mrkdwn',
            //         'text': `*Response*: ${key}`
            //       });
            //   return accumulator;
            // }, [])),
            {
              'type': 'mrkdwn',
              'text': `*Instructions*: ${(dialog.highlights ? dialog.highlights : []).length}`
            },
            {
              'type': 'mrkdwn',
              'text': `*Tips*: ${(dialog.tips ? dialog.tips : []).length}`
            },
            {
              'type': 'mrkdwn',
              'text': `*Reminders*: ${(dialog.reminders ? dialog.reminders : []).length}`
            },
            {
              'type': 'mrkdwn',
              'text': `${Object.keys(errors).length}❗ ${Object.keys(warnings).length}⚠️`
            }

          ]
        }
      ]
    })
      .catch((err: Error) => {
        console.error('Failed to notify', err);
      });
  }

  private static timeline(insight: IInsight): string {
    let txt = '';
    // + event.timelineStart ? (`${event.timelineStart}${typeof event.timelineEnd === 'number' ? '-' + event.timelineEnd : ''} ${typeof event.timelineBreedOffset === 'number' && '(' + event.timelineBreedOffset + ' offset)'}`) : 'N/A'
    if (typeof insight.timelineStart === 'number') {
      txt += `${insight.timelineStart}`;
      if (typeof insight.timelineEnd === 'number') {
        txt += `-${insight.timelineEnd}`;
        if (typeof insight.timelineBreedOffset === 'number') {
          txt += ` (${insight.timelineBreedOffset} offset)`;
        }
      }
      txt += ' days';
    } else {
      txt += 'N/A';
    }
    return txt;
  }


}
